import { Directive, HostListener } from '@angular/core';

import { TypedDialogService } from '@libs/src/typed-dialog/typed-dialog.service';

import { PreviewImageDialogComponent } from './preview-image-dialog.component';

@Directive({
  selector: '[appPreviewImages]',
  standalone: false,
})
export class PreviewImagesDirective {
  constructor(private readonly dialog: TypedDialogService) {}

  previewImage(element: HTMLImageElement) {
    const imageSrc = element.getAttribute('src');
    if (imageSrc) {
      this.dialog.open(PreviewImageDialogComponent, {
        data: imageSrc,
        maxWidth: '95vw',
      });
    }
  }

  @HostListener('click', ['$event.target'])
  click(element: HTMLImageElement | null) {
    if ('img' === element?.tagName.toLowerCase() && !element?.closest('a')) {
      this.previewImage(element);
      return false;
    }
  }
}
